import http from '@utils/https'

export const state = {
  // website options
  options: {
    home: {
      title: "Inicio",
      description: "Qué es Biblioteca Digitales?",
      url: "/home",
      id: "home",
      icon: 'house-door',
      active: true
    },
    services: {
      title: "Servicios",
      description: "Biblioteca digital es un plataforma diseñada especialmente para bibliotecas. <br/> Proveemos resultados acorde a las necesidades de cada institución con interfaz sencilla y amigable.",
      url: "/services",
      id: "services",
      icon: 'bounding-box',
      active: true
    },
    webinars: {
      title: "Webinars",
      description: "Webinar y Videos",
      url: "/webinars",
      id: "webinars",
      icon: 'camera-video',
      active: true
    },
    clients: {
      title: "Clientes",
      description: "Nuestros clientes son nuestra mejor carta de recomendación",
      url: "/clients",
      id: "clients",
      icon: 'people',
      active: true
    },
    publishers: {
      title: "Editoriales",
      description: "Nuestros fondos editoriales",
      url: "/publishers",
      id: "publishers",
      icon: 'book',
      active: true
    },
    contact: {
      title: "Contacto",
      description: "Complete el siguiente formulario para solicitar una prueba de la biblioteca digital",
      url: "/contact",
      id: "contact",
      icon: 'chat-text',
      active: true
    },
    trials: {
      title: "Contacto",
      description: "Complete el siguiente formulario para solicitar una prueba de la biblioteca digital",
      url: "/trials",
      id: "trials",
      icon: 'chat-text',
      active: false
    },
  },

  // social accounts
  social: [
    {id: 'facebook', url: 'https://www.facebook.com/BibliotecasDg/'},
    {id: 'twitter', url: 'https://twitter.com/BibliotecasDg'},
    {id: 'instagram', url: 'https://www.instagram.com/bibliotecasdigitales/'},
    // {id: 'telephone', url: 'https://wa.link/xg45v5'},
  ],

  // banners
  banners: [
    { id: '01', src: require('@assets/banners/banner_10.png') },
    { id: '02', src: require('@assets/banners/banner_11.png') },
    { id: '03', src: require('@assets/banners/banner_12.png') },
    { id: '04', src: require('@assets/banners/banner_13.png') },
    { id: '05', src: require('@assets/banners/banner_14.png') },
    { id: '06', src: require('@assets/banners/banner_15.png') },
    { id: '07', src: require('@assets/banners/banner_16.jpg') },
    { id: '08', src: require('@assets/banners/banner_17.jpg') },
  ],

  // features
  features: [
    { id: 'micrositios', icon: 'sitemap', description: 'Generación de micrositios por institución educativa o biblioteca.' },
    { id: 'drm', icon: 'file', description: 'Lectura en línea o descarga con DRM.' },
    { id: 'responsive', icon: 'desktop', description: 'Resposive Design para cada micrositio.' },
    { id: 'concurrencia', icon: 'users', description: 'Límite de concurrencia de usuarios.' },
    { id: 'perosnalizado', icon: 'user', description: 'Accesos personalizados.' },
    { id: 'pdf', icon: 'file-pdf', description: 'Distribución de contenidos en PDF.' },
    { id: 'medida', icon: 'images', description: 'Desarrollo y diseño gráfico a la medida.' },
    { id: 'control', icon: 'download', description: 'Número de descargas controladas.' },
    { id: 'soporte', icon: 'ticket-alt', description: 'Soporte y asistencia técnica.' },
  ],

  // page content
  info: {
    home: {
      intro: "Pensando en los bibliotecarios, maestros y alumnos, Bibliotecas Digitales ofrece una plataforma en\n" +
          "        línea que facilita el acceso a libros especializados completamente en español; cuenta con un amplio\n" +
          "        catálogo enfocado en diversas áreas de estudio con el objetivo de acercar el conocimiento de forma\n" +
          "        rápida y eficaz a todos sus usuarios.",
      video: 'R5A9ww2Uy7Y',
      title: "Servicios Digitales Especializados",
      subtitle: "en distribución de contenido para bibliotecas e instituciones"
    },
    services: {
      intro: 'Biblioteca Digital  cuenta con una amplia colección de libros electrónicos en español en áreas como Administración, ' +
          'Ciencia y Tecnología, Computación, Educación, Escolar y Bachillerato, Interés General, entre otros. Nuestra plataforma ' +
          'está configurada sobre el ecosistema iPublishCentral, un modelo en constante actualización y mejora cuya infraestructura ' +
          'se implementa de forma rápida y a la medida de cada biblioteca. Ofrecemos modelos de licenciamiento de libros ' +
          'electrónicos de acuerdo a las necesidades y requerimientos de cada Biblioteca.',
      image: require('@assets/images/diagrama.png'),
      title: 'Beneficios de su Biblioteca Digital',
      subtitle: 'Su biblioteca digital lista en tan solo 1 semana',
      text: 'Principales servicios',
      text2: 'Configure la biblioteca de acuerdo a las necesidades',
      list: [
        { id: '01', icon: 'key', description: 'Acceso por Usuario', details: 'Se asigna un nombre y contraseña a cada miembro de la institución para acceder a los contenidos suscritos.' },
        { id: '02', icon: 'network-wired', description: 'Acceso por IP', details: 'Se asigna el o los rangos que la institución determine para que de manera automática los usuarios puedan acceder a los contanidos suscritos.' },
        { id: '03', icon: 'window-maximize', description: 'Acceso por URL referida', details: 'Se crea un enlace en cualquier sitio web; los usuarios dan clic en este enlace, serán rederigidos al sitio y accederan al contenido de manera automática.' },
        { id: '04', icon: 'cloud', description: 'Ahorro de espacio y dinero'},
        { id: '05', icon: 'columns', description: 'Panel Bibliotecario'},
        { id: '06', icon: 'book-reader', description: 'Lectura en Línea y por Descarga.'},
        { id: '07', icon: 'chart-line', description: 'Análisis del cliente'},
        { id: '08', icon: 'coins', description: 'Ventas Licenciadas'},
        { id: '09', icon: 'user-shield', description: 'Accesos Controlados'},
        { id: '10', icon: 'mobile-alt', description: 'Distribución Multiplataforma'},
        { id: '11', icon: 'lock', description: 'Sistema DRM'},
      ],
      benefits: [
        { id: '01', icon: 'check-circle', description: 'Interfaz sencilla, amigable, incluye buscador por título' },
        { id: '02', icon: 'check-circle', description: 'Consulta de los usuarios las 24 horas de los 365 días del año.' },
        { id: '03', icon: 'check-circle', description: 'Asesoría y Capacitación por parte de soporte técnico.' },
        { id: '04', icon: 'check-circle', description: 'Instituciones con múltiples campus.' },
        { id: '05', icon: 'check-circle', description: 'Cobertura de todos sus usuarios.' },
        { id: '06', icon: 'check-circle', description: 'Los libros no se maltratan o pierden.' },
        { id: '07', icon: 'check-circle', description: 'Imagen personalizada.' },
        { id: '08', icon: 'check-circle', description: 'Chat en vivo para apoyo de sus usuarios.' },
        { id: '09', icon: 'check-circle', description: 'Importantes ahorros de espacios físicos.' },
        { id: '10', icon: 'check-circle', description: 'Lectura online y por descarga.' },
        { id: '11', icon: 'check-circle', description: 'Herramientas que facilitan la lectura.' },
        { id: '12', icon: 'check-circle', description: 'Elija los títulos que necesite.' },
        { id: '13', icon: 'check-circle', description: 'Personalización de categorías.' },
        { id: '14', icon: 'check-circle', description: 'Reportes de usabilidad al instante.' },
        { id: '15', icon: 'check-circle', description: 'Acceso controlado a los contenidos.' },
        { id: '16', icon: 'check-circle', description: 'No requiere equipos especiales.' },
        { id: '17', icon: 'check-circle', description: 'Perfil para Bibliotecario para realizar consultas.' },
        { id: '18', icon: 'check-circle', description: 'Disponible para equipos de escritorio y móviles.' },
      ]
    },
    webinars: {
      intro: 'Los webinars de bibliotecas digitales, son conferencias digitales desarrolladas y presentadas por los ' +
          'autores que colaboran con la editorial Alfaomega. Cada uno de ellos comparte con el público su pasión, ' +
          'tiempo y conocimiento para tener un mayor entendimiento de los temas actuales, que ayudan a los alumnos ' +
          'y maestros a enriquecer su práctica docente y estudio diario.',
      image: require('@assets/images/webinars.png'),
      title: 'Beneficios de los Webinars',
      subtitle: 'Contacto directo con el conocimiento',
      benefits: [
        { id: '01', icon: 'check-circle', description: 'Encuentra tutoriales sobre el uso de algunas aplicaciones o herramientas de libros.' },
        { id: '02', icon: 'check-circle', description: 'Escuchar al autor dar una explicación más detallada de algún tema relacionado con sus libros.' },
        { id: '03', icon: 'check-circle', description: 'Tener contacto directo con los autores para aclarar dudas por medio del chat directo.' },
        { id: '04', icon: 'check-circle', description: 'Son una herramienta de estudio para los alumnos.' },
        { id: '05', icon: 'check-circle', description: 'Se pueden visualizar las 24 hrs. y 365 días del año.' }
      ]
    },
    clients: {
      list: [
        { name: 'Asociacion Sinaloense para el Bienestar Social', image: 'QFjtu0OOOs.png' },
        { name: 'CECyTE Michoacan', image: '7FqwlsWBXT.png' },
        { name: 'Colegio de Bachilleres del Estado de Sonora', image: 'i2DtKme8QX.png' },
        { name: 'Comision Nacional Bncaria y de Valores', image: 'zD8oFQUw5p.png' },
        { name: 'ESIA Zacatenco', image: '2auZFgDNab.png' },
        { name: 'ESIME AZCAPOTZALCO', image: 'eXBhEpDkJd.png' },
        { name: 'FES Cuautitlan', image: '6Kg2vwx19n.png' },
        { name: 'Gob del DF Del Iztacalco', image: '6He8CxAXe9.png' },
        { name: 'Instituto de Cultura de B C', image: 'fIRHs2E9sX.png' },
        { name: 'Instituto Tecnologico de  S L P', image: '3lJ3kf8JpG.png' },
        { name: 'Instituto Tecnologico de Apizaco', image: 'R8RmB8HSaV.png' },
        { name: 'Instituto Tecnologico de Celaya', image: 'o43MmX3vss.png' },
        { name: 'Instituto Tecnologico de Chilpo', image: 'iGwM4H540J.png' },
        { name: 'Instituto Tecnologico de G A M', image: 'KExInYdD44.png' },
        { name: 'Instituto Tecnologico de Puebla', image: 'rrLRB2ynum.png' },
        { name: 'Instituto Tecnologico de Tehuacan ', image: 'S6Y4gxBsz8.png' },
        { name: 'Instituto Tecnologico de Tijuana', image: 'Wum7WknsBq.png' },
        { name: 'INSTITUTO TECNOLOGICO DE TLAJOMULCO', image: 'QzkyZRIoNd.png' },
        { name: 'Instituto Tecnologico de Tlalnepantla', image: 'emKoBdWvk1.png' },
        { name: 'Instituto Tecnologico de Toluca', image: 'l6oaqOP6p2.png' },
        { name: 'Inst Tec Sup de Alamo Temapache', image: 'Xj2HQVBOcn.png' },
        { name: 'Instituto Tecnologico Superior de Huichapan', image: 'EwSCSFvC5d.png' },
        { name: 'Instituto Tecnologico Superior de Uruapan', image: 'h73krbcbtx.png' },
        { name: 'IPN UPIITA', image: 'W3dcw84h7R.png' },
        { name: 'ITESM Queretaro', image: 'Y8tNhsJpQC.png' },
        { name: 'ITS Alvarado', image: 'QxjjjTrctN.png' },
        { name: 'Municipio Apaseo el Grande Guanajuato', image: 'gSB8wrZTqs.png' },
        { name: 'Municipio de Chapala', image: 'amuwatkuDQ.png' },
        { name: 'Municipio de Cortazar Guanajuato', image: 'OcBbMWKGva.png' },
        { name: 'Mpo de Dolores Hidalgo Gto', image: 'Mct4WG4O0K.png' },
        { name: 'Municipio de la Paz', image: '2h1s5qoVAp.png' },
        { name: 'Municipio de los Cabos', image: 'mbUIySFsY3.png' },
        { name: 'Tecnologico a Distancia Tuxtla', image: '0iQcGgIvZt.png' },
        { name: 'UAEM', image: 'K6ObKS5UrS.png' },
        { name: 'UAEM Temascaltepec', image: '5ullFylBEb.png' },
        { name: 'UAM XOCHIMILCO', image: 'vGMZXumqXs.png' },
        { name: 'UAM IZTAPALAPA', image: 'zZzQSCUxb1.png' },
        { name: 'UDG CU Valles', image: 'u7XSApqdAo.png' },
        { name: 'UNAM Facultad de Conta y Admon', image: 'em4gHBMwP8.png' },
        { name: 'Universidad Autonoma de Chiapas', image: 'I40zeGQlok.png' },
        { name: 'UNIVERSIDAD AUTONOMA DE SINALOA', image: 'xXzd0zjDBD.png' },
        { name: 'UNIVERSIDAD AUTONOMA DEL CARMEN', image: '0hMbsLHwW8.png' },
        { name: 'Universidad Autonoma del Estado de Hidalgo', image: 'W6SXnFRmGR.png' },
        { name: 'Universidad Contemporanea', image: 'h7QLX0NvIX.png' },
        { name: 'Universidad de Celaya', image: 'gkDYVvlaTN.png' },
        { name: 'Universidad de Colima', image: 'YkOQRpCT6M.png' },
        { name: 'Universidad de Guanajuato', image: 'hYdsgXmgcb.png' },
        { name: 'Universidad de Montemorelos', image: 'eodh7sCI8X.png' },
        { name: 'Universidad De Quintana Roo', image: '8EeqmotBZy.png' },
        { name: 'Universidad de Sonora', image: 'anGe23afWd.png' },
        { name: 'Universidad del Este', image: 'QHTckRW39n.png' },
        { name: 'U INTERAMERICANA PARA EL DESARROLLO', image: 'aN9e2Rb6uH.png' },
        { name: 'Universidad Latinoamericana', image: 'GbNVCaG7IC.png' },
        { name: 'UNIVERSIDAD LIBRE DE PEREIRA', image: 'DeA2Dhdyk4.png' },
        { name: 'UNIVERSIDAD POLITECNICA DE B C', image: '1QanFKG1OA.png' },
        { name: 'Universidad Tecnologica de Aguascalientes', image: '1tZJAgv1QU.png' },
        { name: 'Universidad Tecnologica de Queretaro', image: 'z6OTXNWgRj.png' },
        { name: 'Universidad Virtual de Guadalajara', image: 'aprMgQojAS.png' },
      ],
      disclaimer: 'Las marcas y logos mostrados en el Sitio Web son propiedad de sus respectivos dueños y se usan sólo de manera informativa sin fines de lucro.'
    },
    publishers: {
      list: [
        { id: 1, name: 'Asociacion Sinaloense para el Bienestar Social', image: 'QFjtu0OOOs.png', website: 'https://www.alfaomega.com.mx', description: 'A description' },
        { id: 2, name: 'CECyTE Michoacan', image: '7FqwlsWBXT.png', website: 'https://www.alfaomega.com.mx', description: 'A description' },
      ],
      disclaimer: 'Las marcas y logos mostrados en el Sitio Web son propiedad de sus respectivos dueños y se usan sólo de manera informativa sin fines de lucro.'
    },
    contact: {
      video: 'R5A9ww2Uy7Y',
      disclaimer: 'Los datos personales que nos proporcione serán protegidos conforme a lo dispuesto por las leyes federales aplicables en cada país, los cuales serán incorporados y tratados en el sistema de datos personales.'
    }
  },

  // dummy data
  data: null,
}

export const mutations = {
  SET_CONTENT(state, data) {
    state.options = data.options;
    state.social = data.social;
    state.banners = data.banners;
    state.featutes = data.featutes;
    state.info = data.info;
  },
}

export const getters = {

  /**
   * Return the active options
   *
   * @param state
   * @return {{}}
   */
  menuOptions(state) {
    return Object.keys(state.options)
        .filter(key => state.options[key].active)
        .reduce((obj, key) => {
          obj[key] = state.options[key];
          return obj;
        }, {});
  },
}

export const actions = {
  // Module initialization
  init({ state, dispatch }) {
    dispatch('fetch', {})
  },

  /**
   * Load the app content from the server
   *
   * @param commit
   * @param state
   * @param rootState
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  fetch({ commit, state, rootState }, params) {

    return http.get(`/api/hablemos/content`)
        .then((response) => {
          if (response.data.status === 'success') {
            commit('SET_CONTENT', response.data.data)
          }
          return response.data
        })
        .catch((error) => {
          console.error(error)
        })
  },

  /**
   * Submit the contact form
   *
   * @param commit
   * @param state
   * @param rootState
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  submit({ commit, state, rootState }, params) {
    return http.post(`/api/hablemos/trial`, params)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          console.error(error)
        })
  }
}

